import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { AuthInterceptorService } from './core/interceptors/auth-interceptor.service';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { FormsModule } from '@angular/forms';

import { SharedModule } from './shared/modules/primeng.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RestartPasswordComponent } from './components/restart-password/restart-password.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { ApiCore } from './config/api';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { CreditsInfoComponentComponent } from './components/credits-info-component/credits-info-component.component';
import { AuthModule } from './pages/auth/auth.module';
import { BtnFullScreenComponent } from './components/btn-full-screen/btn-full-screen.component';
import { WalletComponent } from './components/wallet/wallet.component';
import { BannerModule } from './components/banner/banner.module';
import { RedirectComponent } from './components/redirect/redirect.component';
import { MessageService } from 'primeng/api';
import { ToastService } from './shared/services/toast.service';
import { BottomMenuComponent } from './layouts/main-layout/components/bottom-menu/bottom-menu.component';
import { MenuComponent } from './layouts/main-layout/components/menu/menu.component';
import { MenuItemComponent } from './layouts/main-layout/components/menu-item/menu-item.component';
import { RandomIconComponent } from './layouts/main-layout/components/menu-item/random-icon/random-icon.component';
import { SocialLinksComponent } from './layouts/main-layout/components/social-links/social-links.component';
import { MyCreditsComponent } from './components/my-credits/my-credits.component';
import { CreditsBonosInfoComponent } from './components/credits-bonos-info/credits-bonos-info.component';
import { BonosComponent } from './components/notifications/bonos/bonos.component';
import { CajeroComponent } from './components/notifications/cajero/cajero.component';
import { ModalBonusComponent } from './components/notifications/bonos/components/modal-bonus/modal-bonus.component';
import { ProfileMenuComponent } from './components/profile-menu/profile-menu.component';
import { ProfileIconComponent } from './components/profile-icon/profile-icon.component';
import { ModalCajeroComponent } from './components/notifications/cajero/components/modal-cajero/modal-cajero.component';
import { TablePaginationComponent } from './shared/components/table-pagination/table-pagination.component';
import { MainMenuMobileComponent } from './components/main-menu-mobile/main-menu-mobile.component';
import { ConfigService } from './shared/services/initializer.service';
import { LazyLoadDirective } from './directives/lazy-load.directive';
import { CreateAccountModalComponent } from './components/create-account-modal/create-account-modal.component';
import { LoginModalComponent } from './components/login-modal/login-modal.component';
import { SidebarComponent } from './layouts/main-layout/components/sidebar/sidebar.component';
import { SupplierVerificationDialogComponent } from './components/paid-supplier-verification/supplier-verification-dialog.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export function loadConfig(configService: ConfigService) {
  return () => configService.loadConfig();
}

// const config: SocketIoConfig = {
// 	url: ApiCore.BASE_URL + 'enter-game', // socket server url;
// 	options: {
// 		 transports: ['websocket'],
//     extraHeaders:{
//       Authorization: `Bearer ${localStorage.getItem('token')}`
//     }

// 	}
// }

@NgModule({
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    AppLayoutComponent,
    NotFoundComponent,
    LanguageSelectorComponent,
    RestartPasswordComponent,
    MainLayoutComponent,
    BtnFullScreenComponent,
    WalletComponent,
    RedirectComponent,
    BottomMenuComponent,
    MenuComponent,
    MenuItemComponent,
    RandomIconComponent,
    SocialLinksComponent,
    MyCreditsComponent,
    CreditsBonosInfoComponent,
    BonosComponent,
    CajeroComponent,
    ModalBonusComponent,
    ProfileMenuComponent,
    ProfileIconComponent,
    ModalCajeroComponent,
    TablePaginationComponent,
    MainMenuMobileComponent,
    LazyLoadDirective,
    SidebarComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    SharedModule,
    BrowserAnimationsModule,
    FormsModule,
    TranslateModule.forRoot({
        defaultLanguage: 'es-MX',
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
        },
    }),
    AuthModule,
    BannerModule,
    LoginModalComponent,
    CreateAccountModalComponent,
    SupplierVerificationDialogComponent,
],
  exports: [SharedModule,
  ],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfig,
      deps: [ConfigService],
      multi: true,
    },
    MessageService,
    ToastService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
